import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import CustomDropdown from "../../../constants/CustomDropdown";
import CustomTableWithAll from "../../../constants/CustomTableWithAll";
import CustomHeading from "../../../constants/CustomHeading";
import {getCurriculumData, getTermsData, getCourseCurriculumData, getLabExperimentData  } from "../../../redux/actions/dataAction";
import CustomFilter from '../../../constants/CustomFilter';


const Manage_Lab_Experiment_Tlos = (props) => {

	useEffect(() => {
		props.getCurriculumData()
		props.getCourseCurriculumData()
		props.getTermsData()
		props.getLabExperimentData()
	}, [])

	const [filter,setFilter]=useState({
		term:'Select Term',
		curriculum:'Select Curriculum',
		course:'Select Course'
	})

	const handleChange=(event)=>{
		setFilter(({...filter,[event.target.id]:event.target.value}))  
	}



	const [filterCourseData,setFilterCourseData]=useState([]);
	const [filterData,setFilterData]=useState([]);

	const Filter=()=>{
		let term_data= CustomFilter(props?.course_curriculum?.data,[
			{value:filter.term,label:'term',initial_value:'Select Term'},
			{
				value:filter.curriculum,label:'curriculum',
				initial_value:'Select Curriculum'
			}
		]);
		let courses=[]
		let cor = term_data?.map((course) => {
			return (course.domain);
		})
		courses.push({value:cor});
	
		setFilterCourseData([...courses])
	}

	const FilterTableData=()=>{
		let data=CustomFilter(props?.lab_experiment?.data,[{value:filter.course,label:'course',initial_value:'Select Course'}]);
		setFilterData(data);
	}

	const columns = [ 
		{title: "Expt. / Job No.",field:"exp_no"},
		{title: "Experiment / Job Details",field:"experiment_detail"},
		{title: "No. of Session/s per batch estimate",field:"no_of_session"},
		{title: "Marks / Experiment",field:"marks"},
		{title: "Correlation of Experiment with Theory",field:"correlation"},
		{title: "Planned Delivery Date",field:"planned_date_delivary"},
		{title: "Actual Delivery Date",field:"actual_date_delivary"},
		{title:'Created By',field:'created_by'},
	]

	useEffect(()=>{
		Filter()
	},[filter,props?.course_curriculum])

	useEffect(()=>{
		FilterTableData()
	},[props?.course_curriculum,filterCourseData])

  	return (
    	<div className="customContainer mb-5">
			<CustomHeading title="Lab Experiment List" />
			<div className='row'>
				<div className='col-md-6'>
					<CustomDropdown 
					label="Curriculum :"
					data={
						props?.curriculums?.data?.map((cur) => {
							return ({value: cur.name});
						})
					}
					defaultOption={'Select Curriculum'}
					notDefaultOption
					id={'curriculum'}
					onChange={handleChange}
					/>
				</div>
				<div className='col-md-6'>
					<CustomDropdown 
					label="Term :"
					data={
						props?.terms?.data?.map((term) => {
							return ({value: term.name});
						})
					}
					defaultOption={'Select Term'}
					notDefaultOption
					id={'term'}
					onChange={handleChange}
					/>
				</div>
				<div className='col-md-6'>
					<CustomDropdown 
					label="Course :"
					data={filterCourseData}
					defaultOption={'Select Course'}
					notDefaultOption
					id={'course'}
					onChange={handleChange}
					/>
				</div>
				<div className='col-md-6'>
					<CustomDropdown 
					label="Category :"
					data={[ {value: 'Demonstration'},
					{value: 'Exercise'},
					{value:'Structured Enquiry'},
					{value: 'Open Ended'}]}
					defaultOption={'Select Category'}
					notDefaultOption
					id={'category'}
					onChange={handleChange}
					/>
				</div>
			</div>
			<CustomTableWithAll data={filterData} title={"Lab Experiments"}  columns={columns} api="/api/lab_experiment" identify="Lab Experiment" />
    	</div>
  	);
};

const mapActionWithProps = {
	getCurriculumData,
	getCourseCurriculumData,
	getTermsData,
	getLabExperimentData,
}

const mapStateWithProps = (state) => (
	{
		curriculums:state.data.curriculums,
		course_curriculum:state.data.course_curriculum,
		terms:state.data.terms,
		lab_experiment:state.data.lab_experiment,
	}
)

export default connect(mapStateWithProps, mapActionWithProps) (Manage_Lab_Experiment_Tlos);
